<template>
  <main-layout>
    <template v-if="view == 'main'">
      <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
        <v-tab :key="0" ripple>{{ $t('Live') }}</v-tab>
        <v-tab :key="1" ripple>{{ $t('Conversation') }}</v-tab>
        <v-tab :key="2" ripple>{{ $t('Products') }}</v-tab>
        <v-tab :key="3" ripple>{{ $t('Payment') }}</v-tab>
        <v-tab-item :key="0">
          <div>
            <v-container>
              <h1 class="mb-3">Live</h1>
              <div v-if="loading" class="text-xs-center">
                
              </div>
              <div v-else>
                <div class="mb-3">
                  <div
                    @click="createLive"
                    style="cursor: pointer;"
                    class="add-conversation text-xs-center"
                  >
                    <i class="fa fa-plus middle"></i>
                    {{ $t('Create Live') }}
                  </div>
                </div>
                <div>
                  <div class="mb-3" v-for="liveitem in liveitems" :key="liveitem.id">
                    <div class="z-border-red px-2 py-2">
                      <div>{{ liveitem.name }}</div>
                      <v-layout wrap>
                        <v-flex
                          v-if="liveitem.status == 'draft'"
                          xs12
                          sm2
                          class="text-xs-center pt-2 pb-2"
                        >
                          <v-chip small> <v-icon small class="mr-2">edit</v-icon>Draft </v-chip>
                        </v-flex>
                        <v-flex
                          v-else-if="liveitem.status == 'live'"
                          xs12
                          sm2
                          class="text-xs-center pt-2 pb-2"
                        >
                          <v-chip dark color="red" small>
                            <span style="font-size: 15px" class="material-icons mr-2"
                              >fiber_manual_record</span
                            >Live
                          </v-chip>
                        </v-flex>
                        <v-flex xs6 sm2 class="text-xs-center">
                          <div class="caption pt-1">Start Live</div>
                          <div v-if="liveitem.startlive" class="primary--text caption pt-1 pb-2">
                            {{ liveitem.startlive | DateFormat('DD/MM/YYYY HH:mm') }}
                          </div>
                          <div v-else class="primary--text caption pt-1 pb-2">-</div>
                        </v-flex>
                        <v-flex xs6 sm2 class="text-xs-center">
                          <div class="caption pt-1">End Live</div>
                          <div v-if="liveitem.endlive" class="primary--text caption pt-1 pb-2">
                            {{ liveitem.endlive | DateFormat('DD/MM/YYYY HH:mm') }}
                          </div>
                          <div v-else class="primary--text caption pt-1 pb-2">-</div>
                        </v-flex>
                        <v-flex xs6 sm2 class="text-xs-center">
                          <div class="caption pt-1">Engagement</div>
                          <div class="primary--text title pt-1 pb-2">{{ liveitem.engagement }}</div>
                        </v-flex>
                        <v-flex xs6 sm2 class="text-xs-center">
                          <div class="caption pt-1">Orders</div>
                          <div class="primary--text title pt-1 pb-2">{{ liveitem.orders }}</div>
                        </v-flex>
                        <v-flex xs12 class="hidden-sm-and-up py-2">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 sm2 class="text-xs-center text-sm-right">
                          <v-btn @click="editLive(liveitem.id)" small fab outline color="primary">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="liveitem.status != 'live'"
                            @click="deleteLive(liveitem)"
                            small
                            fab
                            outline
                            color="primary"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
            <v-divider class="my-3"></v-divider>
            <v-container>
              <h1 v-if="endeditem.length" class=" mb-3 mt-3">History Live</h1>

              <!-- ถ้าไม่มี history ใช้อันนี้ -->
              <!-- <div class="caption grey--text text-xs-center my-3">No history live</div> -->
              <div v-for="(item, k) in endeditem" :key="k" class="z-border-red px-2 py-2 mb-2">
                <v-layout wrap>
                  <v-flex xs12 sm2 class="text-xs-center pt-2 pb-2">
                    <v-chip small color="red " dark style="opacity: 0.5">
                      <v-icon small class="mr-2">stop</v-icon>Stop
                    </v-chip>
                  </v-flex>
                  <v-flex xs6 sm2 class="text-xs-center">
                    <div class="caption pt-1">Start Live</div>
                    <div class="primary--text caption pt-1 pb-2">
                      {{ item.startlive | DateFormat('DD/MM/YYYY HH:mm') }}
                    </div>
                  </v-flex>
                  <v-flex xs6 sm2 class="text-xs-center">
                    <div class="caption pt-1">End Live</div>
                    <div class="primary--text caption pt-1 pb-2">
                      {{ item.endlive | DateFormat('DD/MM/YYYY HH:mm') }}
                    </div>
                  </v-flex>
                  <v-flex xs6 sm2 class="text-xs-center">
                    <div class="caption pt-1">Engagement</div>
                    <div class="primary--text title pt-1 pb-2">{{ item.engagement }}</div>
                  </v-flex>
                  <v-flex xs6 sm2 class="text-xs-center">
                    <div class="caption pt-1">Orders</div>
                    <div class="primary--text title pt-1 pb-2">{{ item.orders }}</div>
                  </v-flex>
                  <v-flex xs12 class="hidden-sm-and-up py-2">
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 sm2 class="text-xs-center text-sm-right">
                    <v-btn @click="showOrderHistory(item.id)" small outline color="primary"
                      >view order</v-btn
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-container>
          </div>
        </v-tab-item>
        <v-tab-item :key="1">
          <intent :showDefault="false" :filter-context="'live'"></intent>
        </v-tab-item>
        <v-tab-item :key="2">
          <v-container>
            <products></products>
          </v-container>
        </v-tab-item>
        <v-tab-item :key="3">
          <Payments></Payments>
        </v-tab-item>
      </v-tabs>
    </template>
    <template v-else-if="view == 'manage'">
      <live-management @changeview="changeview"></live-management>
    </template>
    <div style="height: 60px"></div>
    <v-dialog width="800px" v-model="showorderhistory" persistent>
      <v-card v-if="showorderhistory">
        <div class="text-xs-right">
          <v-btn icon @click="showorderhistory = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pt-0">
          <OrderSummary :liveid="liveid"></OrderSummary>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main-layout>
</template>

<script>
import LiveManagement from './LiveManagement'

import api from '@/api'
import OrderSummary from './OrderSummary.vue'
import Products from './Products.vue'
import Intent from './Intent.vue'
import Payments from '@/components/view/template/ecommerce/Payment.vue'

import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      view: 'manage',
      data: [],
      loading: true,
      livetempid: '',
      liveid: '',
      showorderhistory: false,
      advancedTab: ''
    }
  },
  components: {
    LiveManagement,

    OrderSummary,
    Products,
    Intent,
    Payments
  },
  computed: {
    ...mapGetters(['selectedBot']),
    liveitems() {
      if (this.data) {
        return this.data.filter(el => ['draft', 'live'].includes(el.status))
      } else {
        return []
      }
    },
    endeditem() {
      if (this.data) {
        return this.data.filter(el => ['ended'].includes(el.status))
      } else {
        return []
      }
    }
  },
  mounted() {
    // this.getLiveInfo()
  },
  methods: {
    showOrderHistory(id) {
      this.liveid = id
      this.showorderhistory = true
    },
    changeview(to) {
      this.liveid = to.liveid
      this.view = to.view
      this.getLiveInfo()
    },

    createLive() {
      this.view = 'getstart'
    },
    editLive(id) {
      this.liveid = id
      this.view = 'manage'
    },
    deleteLive(item) {
      var vm = this
      this.$swal
        .fire({
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          text: this.$t('Do you want to delete {name}?', { name: item.name })
        })
        .then(result => {
          if (result.value) {
            api.deleteliveinfo(
              { pageid: vm.selectedBot.pageid, liveid: item.id },
              (err, response) => {
                this.data.splice(
                  this.data.findIndex(el => el.id == item.id),
                  1
                )
              }
            )
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/Main.vue